window.addEventListener('load', function() {
  // Only load Google Maps API if this page has address autocomplete fields
  if (!document.getElementsByClassName('places_address').length) return;

  // Restore native Array.from — Prototype.js overwrites it with $A which
  // doesn't support iterables, causing Google Maps API v3 warnings.
  try {
    if (typeof Array.from !== 'function' || !Array.from(new Set([1]))[0]) {
      Array.from = (function() {
        var isCallable = function(fn) { return typeof fn === 'function'; };
        return function from(arrayLike) {
          var items = Object(arrayLike);
          var mapFn = arguments.length > 1 ? arguments[1] : void 0;
          var T = arguments.length > 2 ? arguments[2] : void 0;
          if (typeof mapFn !== 'undefined' && !isCallable(mapFn))
            throw new TypeError('Array.from: mapFn must be callable');
          // Handle iterables (Symbol.iterator)
          if (typeof Symbol !== 'undefined' && Symbol.iterator && items[Symbol.iterator]) {
            var arr = [], it = items[Symbol.iterator](), next;
            while (!(next = it.next()).done) {
              arr.push(mapFn ? (T ? mapFn.call(T, next.value, arr.length) : mapFn(next.value, arr.length)) : next.value);
            }
            return arr;
          }
          // Fallback for array-like objects
          var len = items.length >>> 0, result = new Array(len);
          for (var i = 0; i < len; i++) {
            result[i] = mapFn ? (T ? mapFn.call(T, items[i], i) : mapFn(items[i], i)) : items[i];
          }
          return result;
        };
      })();
    }
  } catch(e) {}

  // DEV-11135: the key is no longer in this (shared, CDN-served) bundle. head.tpl writes the
  // referrer-restricted browser key to window._gmapsKey from the platform secret; without it
  // the address fields stay plain inputs and we say so once in the console.
  var key = (typeof window._gmapsKey === 'string') ? window._gmapsKey.trim() : '';
  if (!key) {
    if (window.console && console.warn) console.warn('places.js: Google Maps browser key not configured; address autocomplete disabled');
    return;
  }
  var lang = document.documentElement.lang || 'en';
  var s = document.createElement('script');
  s.src = '//maps.google.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&language=' + encodeURIComponent(lang) + '&loading=async&callback=googleplaces';
  s.async = true;
  document.head.appendChild(s);
});

let placeid='';
let componentForm = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  country: 'long_name',
  postal_code: 'short_name'
};

function checkenterkey(e, id){
  if(e.keyCode === 13){
    getid(id)
  }
}

function getid(id){
  let classname = id.className;    
  let classindex = classname.indexOf('places_address_');
  let idsub = classname.substring(classindex+15);

  if(classindex){
    placeid = classname.substring(classindex+15, classindex+15+idsub.indexOf(' '));
    if(placeid=='_') placeid = idsub;
  }
  if(placeid.includes('n') || placeid.includes('cp') || placeid.includes('ct') && typeof id != 'undefined'){
    let uniqueId = id.getAttribute('data-unique_id');
    if(uniqueId) {
      let unique = uniqueId.replace('address_', '');
      placeid = "_"+unique;
    } else if(!placeid.startsWith('_')) {
      // Initial render (no data-unique_id): normalize to '_cp' / '_ct' so selectors resolve
      placeid = "_"+placeid;
    }
  } else if(isNaN(placeid)){
    placeid = '';
  }else{
    placeid = "_"+placeid;
  }
}

function googleplaces(){
  if (typeof google === 'undefined' || !google.maps) {
    console.warn('Google Maps API not loaded — skipping places autocomplete.');
    return;
  }
  let inputs = document.getElementsByClassName('places_address');
  // DEV-13601: fillInAddress only reads address_components. Without `fields` the widget asks Google
  // for every detail of the place (reviews, phone, hours) and bills the expensive rate for it.
  let options = {
      types: ['address'],
      fields: ['address_components']
  };
  for(let input of inputs)
  {
      let autocomplete = new google.maps.places.Autocomplete(input, options);
      autocomplete.addListener('place_changed', fillInAddress)
  }
}

function fillInAddress() {
  let place = this.getPlace(); 
  let street, address, city, country, tempstate, postalCode, state;

  if(placeid.includes('_cp') || placeid.includes('_ct')){
    var match = placeid.match(/_[a-z]{2}_(\d+)/);
    var extractedId = match ? match[1] : null;
    let designator = placeid.replace(/_\d+/g, '');
    var version;
    if(placeid === '_cp' || placeid === '_cp_1'){
      version = '_cp';
    } else if(placeid === '_ct' || placeid === '_ct_1'){
      version = '_ct';
    } else {
      version = `${designator}_${extractedId}`;
    }
    address = document.querySelector(`.places_address${version}`); 
    city = document.querySelector(`.places_city${version}`); 
    country = document.querySelector(`.places_country${version}`); 
    tempstate;
    postalCode = document.querySelector(`.places_zip${version}`); 
    state = document.querySelector(`.places_state${version}`);
    console.log({address:address, city:city, country:country, postalCode:postalCode, state:state}, 'places obj')
  }else{
    address = document.querySelector('.places_address'+placeid); 
    city = document.querySelector('.places_city'+placeid); 
    country = document.querySelector('.places_country'+placeid); 
    tempstate;
    postalCode = document.querySelector('.places_zip'+placeid); 
    state = document.querySelector('.places_state'+placeid);
  }

  // Bail if we couldn't resolve the required fields — prevents null-property errors.
  if(!address || !city || !country || !postalCode){
    console.warn('fillInAddress: could not resolve one or more address fields for placeid "' + placeid + '"', {address, city, country, postalCode, state});
    return;
  }

  postalCode.value = null;
  city.value = null;
  country.value = null;
  place.address_components.forEach(addressComp => {
    let addressType = addressComp.types[0];
    let val = addressComp[componentForm[addressType]];
    if (addressType == "street_number") {
      street = val;
    } else if (addressType == "route"){
      if(street==null){
        let add = address.value.split(',');
        street = add[0];
      }else{
        street += " " + val;
      }
    } else if(addressType == "locality") {
      city.value = val;
    } else if ( !city.value && (addressType == "sublocality_level_1" || addressType == "sublocality")){ // Used for urban places that have more specific city locality values
      city.value = addressComp.long_name;
    }
    else if(addressType == "country"){
      country.value = val
      country_value = val;
    } else if(addressType == "administrative_area_level_1") {
      //state.value = val
      tempstate = val;
      if(state)
        state.setAttribute('data-state',val);
    } else if(addressType == "postal_code") {
      postalCode.value = val;
    }
    // address2Field.focus(); should set this up for encouragement of filling in address2
  });
  address.value = street
  let e = document.createEvent('HTMLEvents');
  e.initEvent('input', true, true);

  address.dispatchEvent(e);
  city.dispatchEvent(e);
  postalCode.dispatchEvent(e);
  setTimeout(function () {
    let x = document.getElementsByClassName("pac-container");
    for(let select of x){
      select.style.display = "none";
    }
  },500)

  let address_obj;
  if (placeid=='_0'){
    address_obj = { 
      name: 'billing_name', 
      nameval: '', 
      state_id: 'billing_state', 
      country_id: 'billing_country', 
      state_name: 'billing[state]', 
      zip_id: 'billing_zip'
    };
  }
  else if (placeid=='_1'){
    address_obj = { 
      name: 'shipping_name', 
      nameval: '', 
      state_id: 'shipping_state', 
      country_id: 'shipping_country', 
      state_name: 'shipping[state]', 
      zip_id: 'shipping_zip'
    };
  }
  else if(placeid.includes('_cp') || placeid.includes('_ct')){ // create account
    let prefix;
    let unique_id;
    if(placeid != '_cp' || placeid != '_ct'){
      prefix = placeid.includes('_cp') ? 'cp' : 'ct'; 
      placeid = placeid.replace(/_cp_|_ct_/, '');
    }else{
      prefix = placeid.replace(/^_/, '');
    }
    unique_id = country.id.match(/address_[a-z]{2}_(\d+)_country/)[1]; 

    address_obj = {
      name: '', 
      nameval: '', 
      state_id: `address_${prefix}_${unique_id}_state`, 
      country_id: `address_${prefix}_${unique_id}_country`, 
      state_name: `address[${prefix}][${unique_id}][state]`, 
      zip_id: `address_${prefix}_${unique_id}_zip`
    };
  }
  else{
    address_obj = {
      name: '', 
      nameval: '', 
      state_id: 'state'+placeid, 
      country_id: 'country'+placeid, 
      state_name: 'address['+placeid.substring(1,placeid.length)+'][state]', 
      zip_id: 'zip'+placeid
    };
  }

  address_obj.set_state = tempstate;
  address_obj.country_value = country_value;
  update_states_on_country_change(address_obj);
}

function clean_errors( city, country ){
  const $city = am.$(city);
  const $country = am.$(country);

  if($city.length > 0 && $city.hasClass('am-error-border') && $city.val() != '')
    $city.trigger('blur');

  if($country.length > 0 && $country.hasClass('am-error-border') && $country.val() != '')
    $country.trigger('blur');
}

function handle_places_address_changes(address){
  const $address = am.$(address);
  const $address_container = $address.parent().closest('.am-section-container--address')

  $address_container.attr('data-address-from-places', 1); 
  var inputs = $address_container.find('input, select').not('[type="hidden"]');
  inputs.on('keyup', () => { 
    $address_container.attr('data-dirty-address', 1); 
  })
}